import axios from "axios";
import { IoMdLink } from "react-icons/io";

export class UtilsClass {

    rankLabel = (rank: number = 0): string => {

        const optionObj:{[key: number]: string} = {
            0: "UR",
            1: "P1",
            2: "P2",
            3: "P3",
            4: "P4"
        };

        return optionObj[rank]
    }

    getCurrencyRates = async () => {
        const ratesObj = await axios.get("https://openexchangerates.org/api/latest.json?app_id=178e2ec246d94cf39384d34c464daec6");

        return ratesObj.data;
    }

    convertToMoney = (amount: number) => {
        const formattedNumber: string = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
        }).format(amount);

        return formattedNumber;
    }

    titleConcat = (title: string, strLength: number) => {
        let titleStr = "";

        if (title) {
            if (title.length > strLength) {
                titleStr = title.slice(0,strLength) + "...";
            } else {
                titleStr = title;
            }
        }       

        return titleStr
    }

    daysUntil(targetDateString: string): number {
        // Convert target date string to a Date object
        const targetDate = new Date(targetDateString);
    
        // Get the current date
        const currentDate = new Date();
    
        // Calculate the difference in milliseconds
        const differenceMs = targetDate.getTime() - currentDate.getTime();
    
        // Convert milliseconds to days
        const days = Math.ceil(differenceMs / (1000 * 60 * 60 * 24));
    
        return days;
    }

    convertRoleToRoleName = (roleCode: string) => {        
        switch (roleCode) {
            case "100":
                return "user";
            case "100,300":
                return "committee";
            case "100,300,500":
                return "admin";
        }

        return "hallooo";
    }

    
    formatURL = (urlString:string) => {
        if (urlString.trim().length > 0)  {
            return <>
                <a href={urlString} target='_blank'><IoMdLink /></a>
            </>
        }

        return <></>
    }

}